import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"
import { NewFavoriteList } from "./types"

export interface GetFavouritesListResponseDataNew extends ResponseData {
  data: NewFavoriteList[]
}

export interface GetFavouritesListResponseNew extends AxiosResponse {
  data: GetFavouritesListResponseDataNew
}
// this is optimized version of getAllFavoriteListApi that returns only the required data
export function getAllFavoriteListOptimizedApi(
  axiosInstance: AxiosInstance,
): Promise<GetFavouritesListResponseNew> {
  return axiosInstance({
    method: "get",
    url: "/user/favouritelist/all-properties-by-userid",
  }) as Promise<GetFavouritesListResponseNew>
}
